var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"play-game"}},[_c('img',{attrs:{"id":"play-game","src":"assets/images/background.png","alt":""},on:{"click":function($event){return _vm.ctrl_game.startGame()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }